import { render, staticRenderFns } from "./EditarHoras.vue?vue&type=template&id=b24e63e6"
import script from "./EditarHoras.vue?vue&type=script&lang=js"
export * from "./EditarHoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports